
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Color } from "../../../../../domain/drawing";

@Component({
})
export default class PropertyEditableMixin extends Mixins() {
  @Prop()
  pallet: Color[];
}
